/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_Recurrence_Event_OnlyInputs */

const vi_error_work_activity_recurrence_event_only = /** @type {(inputs: Error_Work_Activity_Recurrence_Event_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ sự kiện mới cài lặp lại được. Lịch họp, lịch công tác và nhiệm vụ để ở chế độ không lặp.`)
};

/**

* @param {Error_Work_Activity_Recurrence_Event_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_recurrence_event_only = /** @type {((inputs?: Error_Work_Activity_Recurrence_Event_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_Recurrence_Event_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_recurrence_event_only(inputs)
});